"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var runPayloadListeners = function runPayloadListeners(payload, modules) {
  setTimeout(function () {
    if (payload.dispatchValue !== null) {
      modules === null || modules === void 0 ? void 0 : modules.map(function (module) {
        var _module$middleware;

        var payLoadListener = (_module$middleware = module.middleware) === null || _module$middleware === void 0 ? void 0 : _module$middleware.payloadListener;

        if (payLoadListener) {
          payLoadListener(payload);
        }
      });
    }
  }, 0);
};

var _default = runPayloadListeners;
exports["default"] = _default;
module.exports = exports.default;